<section class="flex flex-row justify-center items-start">
  @if (mode === 'resetPassword' && displayPasswordForm) {
    <div fxFlex="300px" class="loginContainer" fxLayout="column" fxLayoutAlign="start center">
      <div fxFlex="60px" fxHide.lt-md></div>
      <h1>Passwort vergessen</h1>
      <p class="text-login">Geben Sie bitte ein neues Passwort ein, um Ihr Passwort zurückzusetzen.</p>
      <div fxLayout="row" style="width: 300px" fxLayoutAlign="center start">
        <form fxLayout="column" fxLayoutGap="10px" (ngSubmit)="onUpdatePassword(f)" #f="ngForm" fxFlex="100%">
          <div fxLayout="column" fxLayoutGap="2px">
            <div fxLayout="row">
              <input type="password" fxFlex="100%" ngModel name="pwd1" placeholder="Passwort" minlength="6" required hintLabel="Muss mindestens 6 Zeichen lang sein" #pwd1="ngModel">
            </div>
            @if (pwd1.invalid && (pwd1.dirty || pwd1.touched)) {
              <div class="alert alert-danger">
                @if (pwd1.hasError('required')) {
                  <div class="formError">Bitte geben Sie Ihr Passwort an</div>
                }
                @if (!pwd1.hasError('required') && (pwd1.value?.length < 6)) {
                  <div class="formError">Ihr Passwort muss mindestens 6 Zeichen lang sein</div>
                }
              </div>
            }
          </div>
          <div fxLayout="column" fxLayoutGap="2px">
            <div fxLayout="row">
              <input type="password" fxFlex="100%" ngModel name="pwd2" placeholder="Passwort wiederholen" minlength="6" required (blur)="checkPasswordConsistency(f)" #pwd2="ngModel">
            </div>
            @if (pwd2.invalid && (pwd2.dirty || pwd2.touched)) {
              <div class="alert alert-danger">
                @if (pwd2.hasError('required')) {
                  <div class="formError">Bitte geben Sie Ihr Passwort erneut an</div>
                }
                @if (!pwd2.hasError('required') && (pwd2.value?.length < 6)) {
                  <div class="formError">Ihr Passwort muss mindestens 6 Zeichen lang sein</div>
                }
              </div>
            }
          </div>
          @if (pwd2.hasError('incorrect')) {
            <div class="formErrorBox" fxLayout="row" fxLayoutAlign="start center">
              <div>
                Ihre angegebenen Passwörter stimmen nicht überein
              </div>
            </div>
          }
          <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start center">
            <button class="button yellow" type="submit" color="primary" [disabled]="!f.touched || !f.valid">Passwort zurücksetzen</button>
          </div>
        </form>
      </div>
      <div fxFlex="20px"></div>
      <img src="../../../assets/img/HEALTH+LIFE-MED.png" width="73"/>
    </div>
  }

  @if (mode === 'recoverEmail' && displayRecoverEmailForm) {
    <div fxFlex="300px" class="loginContainer" fxLayout="column" fxLayoutAlign="start center">
      <div fxFlex="60px" fxHide.lt-md></div>
      <h1>E-Mail Adresse zurücksetzen</h1>
      <p class="text-login">Geben Sie bitte hier Ihre neue E-Mail Adresse ein.</p>
      <div fxLayout="row" style="width: 300px" fxLayoutAlign="center start">
        <form fxLayout="column" fxLayoutGap="10px" (ngSubmit)="onUpdateEMail(g)" #f="ngForm" fxFlex="100%">
          <div fxLayout="column" fxLayoutGap="2px">
            <div fxLayout="row">
              <input type="text" fxFlex="100%" ngModel #email="ngModel" name="email" placeholder="Email-Adresse" email required>
            </div>
            @if (email.invalid && (email.dirty || email.touched)) {
              <div class="alert alert-danger">
                @if (email?.errors.required) {
                  <div class="formError">
                    Bitte geben Sie Ihre Email-Adresse an
                  </div>
                }
                @if (email?.errors.email) {
                  <div class="formError">
                    Bitte geben Sie eine korrekte Email-Adresse an
                  </div>
                }
              </div>
            }
          </div>
          <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start center">
            <button class="button yellow" type="submit" color="primary" [disabled]="!g.touched || !g.valid">Passwort zurücksetzen</button>
          </div>
        </form>
      </div>
      <div fxFlex="20px"></div>
      <img src="../../../assets/img/HEALTH+LIFE-MED.png" width="73"/>
    </div>
  }
</section>
